import React, { ReactNode } from 'react'
import {
  GetTagInstructionsBulletContainer,
  GetTagInstructionsText,
  LineSeparator,
} from '../Instructions.styled'

export const BulletLine = ({
  children,
  underBullet,
}: {
  children: ReactNode
  underBullet?: ReactNode
}) => {
  return (
    <LineSeparator>
      <GetTagInstructionsBulletContainer>
        <GetTagInstructionsText>{children}</GetTagInstructionsText>
      </GetTagInstructionsBulletContainer>
      {Boolean(underBullet) && underBullet}
    </LineSeparator>
  )
}
